import React, { useState, useEffect, useRef } from 'react';
import img1 from '../../assets/images/1.jpg';
import img2 from '../../assets/images/2.jpg';
import img3 from '../../assets/images/3.jpg';
import img4 from '../../assets/images/4.jpg';
import img5 from '../../assets/images/5.jpg';
import img6 from '../../assets/images/6.jpg';
import img7 from '../../assets/images/7.jpg';
import img8 from '../../assets/images/8.jpg';
import img9 from '../../assets/images/9.jpg';
import img10 from '../../assets/images/10.jpg';
import img11 from '../../assets/images/11.jpg';
import img12 from '../../assets/images/12.jpg';
import img13 from '../../assets/images/13.jpg';
import img14 from '../../assets/images/14.jpg';
import img15 from '../../assets/images/15.jpg';
import img16 from '../../assets/images/16.jpg';
import img17 from '../../assets/images/17.jpg';
import img18 from '../../assets/images/18.jpg';
import img19 from '../../assets/images/19.jpg';
import img20 from '../../assets/images/20.jpg';
import img21 from '../../assets/images/21.jpg';
import img22 from '../../assets/images/22.jpg';
import img23 from '../../assets/images/23.jpg';
import img24 from '../../assets/images/24.jpg';

const CourseFeaturesSection = () => {
  const [currentSlide, setCurrentSlide] = useState(1);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);
  const sectionRef = useRef(null);
  const cardsRef = useRef(null);
  
  const totalSlides = 6;
  const cardsPerSlide = 4;
  const totalCards = totalSlides * cardsPerSlide;
  
  // Extended cards data for all 6 slides
  const featuresData = [
    [
      {
        title: "AWS Core Services",
        subtitle: "(EC2, S3, VPC, IAM, CloudWatch)",
        image: img1,
        alt: "AWS Core Services"
      },
      {
        title: "CI/CD Pipelines",
        subtitle: "(Git, Jenkins, GitHub Actions)",
        image: img2,
        alt: "CI/CD Pipelines"
      },
      {
        title: "Docker & Kubernetes",
        subtitle: "fundamentals",
        image: img3,
        alt: "Docker & Kubernetes"
      },
      {
        title: "Infrastructure Code",
        subtitle: "fundamentals",
        image: img4,
        alt: "Infrastructure as Code"
      }
    ],
    [
      {
        title: "Terraform",
        subtitle: "Infrastructure as Code",
        image: img5,
        alt: "Terraform"
      },
      {
        title: "Microservices",
        subtitle: "Architecture & Implementation",
        image: img6,
        alt: "Microservices"
      },
      {
        title: "AWS Lambda",
        subtitle: "Serverless Computing",
        image: img7,
        alt: "AWS Lambda"
      },
      {
        title: "GitHub Actions",
        subtitle: "CI/CD Automation",
        image: img8,
        alt: "GitHub Actions"
      }
    ],
    [
      {
        title: "Cloud Security",
        subtitle: "Best Practices & Tools",
        image: img9,
        alt: "Cloud Security"
      },
      {
        title: "API Gateway",
        subtitle: "Service Integration",
        image: img10,
        alt: "API Gateway"
      },
      {
        title: "EKS & ECS",
        subtitle: "Container Orchestration",
        image: img11,
        alt: "EKS & ECS"
      },
      {
        title: "Monitoring & Logging",
        subtitle: "CloudWatch & ELK Stack",
        image: img12,
        alt: "Monitoring & Logging"
      }
    ],
    [
      {
        title: "Service Mesh",
        subtitle: "Istio & Linkerd",
        image: img13,
        alt: "Service Mesh"
      },
      {
        title: "Configuration Management",
        subtitle: "Ansible & Chef",
        image: img14,
        alt: "Configuration Management"
      },
      {
        title: "Secrets Management",
        subtitle: "AWS Secrets Manager & Vault",
        image: img15,
        alt: "Secrets Management"
      },
      {
        title: "DevSecOps",
        subtitle: "Pipeline Security",
        image: img16,
        alt: "DevSecOps"
      }
    ],
    [
      {
        title: "Serverless Framework",
        subtitle: "Architecture & Development",
        image: img17,
        alt: "Serverless Framework"
      },
      {
        title: "AWS CDK",
        subtitle: "Infrastructure as Code",
        image: img18,
        alt: "AWS CDK"
      },
      {
        title: "Container Security",
        subtitle: "Docker & Kubernetes",
        image: img19,
        alt: "Container Security"
      },
      {
        title: "Automated Testing",
        subtitle: "Continuous Testing",
        image: img20,
        alt: "Automated Testing"
      }
    ],
    [
      {
        title: "Disaster Recovery",
        subtitle: "AWS Solutions",
        image: img21,
        alt: "Disaster Recovery"
      },
      {
        title: "Cost Optimization",
        subtitle: "AWS Cost Explorer",
        image: img22,
        alt: "Cost Optimization"
      },
      {
        title: "High Availability",
        subtitle: "Architecture & Implementation",
        image: img23,
        alt: "High Availability"
      },
      {
        title: "Performance Optimization",
        subtitle: "Best Practices",
        image: img24,
        alt: "Performance Optimization"
      }
    ]
  ];
  
  // Handler for touch events
  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };
  
  const handleTouchMove = (e) => {
    setTouchEndX(e.touches[0].clientX);
  };
  
  const handleTouchEnd = () => {
    if (!isMobile || isAnimating) return;
    
    const minSwipeDistance = 50;
    const swipeDistance = touchEndX - touchStartX;
    
    if (swipeDistance > minSwipeDistance) {
      // Swiped right - go to previous card
      prevCard();
    } else if (swipeDistance < -minSwipeDistance) {
      // Swiped left - go to next card
      nextCard();
    }
    
    // Reset touch coordinates
    setTouchStartX(0);
    setTouchEndX(0);
  };
  
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 576);
    };
    
    // Check initially
    checkIfMobile();
    
    // Add resize listener
    window.addEventListener('resize', checkIfMobile);
    
    // Cleanup
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);
  
  // Add a helper function to get the global card position
  const getGlobalCardPosition = () => {
    return ((currentSlide - 1) * cardsPerSlide) + (currentCardIndex + 1);
  };

  // Add a helper function to set slide and card index from global position
  const setPositionFromGlobal = (globalPosition) => {
    // Adjust to 0-based indexing for calculation
    const zeroBasedPosition = globalPosition - 1;
    
    // Calculate slide (1-based) and card index (0-based)
    const slideNumber = Math.floor(zeroBasedPosition / cardsPerSlide) + 1;
    const cardIndex = zeroBasedPosition % cardsPerSlide;
    
    return { slideNumber, cardIndex };
  };
  
  // Update the nextCard function
  const nextCard = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    
    // Get current global position
    const currentGlobalPosition = getGlobalCardPosition();
    
    // Calculate next global position with wrapping
    const nextGlobalPosition = currentGlobalPosition === totalCards 
      ? 1  // Wrap to first card
      : currentGlobalPosition + 1;
    
    // Get slide and card index from global position
    const { slideNumber, cardIndex } = setPositionFromGlobal(nextGlobalPosition);
    
    const cardsContainer = cardsRef.current;
    cardsContainer.classList.add('slide-out-left');
    
    setTimeout(() => {
      setCurrentSlide(slideNumber);
      setCurrentCardIndex(cardIndex);
      cardsContainer.classList.remove('slide-out-left');
      cardsContainer.classList.add('slide-in-right');
      
      setTimeout(() => {
        cardsContainer.classList.remove('slide-in-right');
        setIsAnimating(false);
      }, 600);
    }, 400);
  };
  
  // Update the prevCard function
  const prevCard = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    
    // Get current global position
    const currentGlobalPosition = getGlobalCardPosition();
    
    // Calculate previous global position with wrapping
    const prevGlobalPosition = currentGlobalPosition === 1 
      ? totalCards  // Wrap to last card
      : currentGlobalPosition - 1;
    
    // Get slide and card index from global position
    const { slideNumber, cardIndex } = setPositionFromGlobal(prevGlobalPosition);
    
    const cardsContainer = cardsRef.current;
    cardsContainer.classList.add('slide-out-right');
    
    setTimeout(() => {
      setCurrentSlide(slideNumber);
      setCurrentCardIndex(cardIndex);
      cardsContainer.classList.remove('slide-out-right');
      cardsContainer.classList.add('slide-in-left');
      
      setTimeout(() => {
        cardsContainer.classList.remove('slide-in-left');
        setIsAnimating(false);
      }, 600);
    }, 400);
  };
  
  const nextSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    
    const cardsContainer = cardsRef.current;
    cardsContainer.classList.add(isMobile ? 'slide-out-left' : 'slide-out-left');
    
    setTimeout(() => {
      setCurrentSlide(prev => (prev === totalSlides ? 1 : prev + 1));
      setCurrentCardIndex(0); // Reset to first card when changing slides on mobile
      cardsContainer.classList.remove(isMobile ? 'slide-out-left' : 'slide-out-left');
      cardsContainer.classList.add(isMobile ? 'slide-in-right' : 'slide-in-right');
      
      setTimeout(() => {
        cardsContainer.classList.remove(isMobile ? 'slide-in-right' : 'slide-in-right');
        setIsAnimating(false);
      }, 600);
    }, 400);
  };
  
  const prevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    
    const cardsContainer = cardsRef.current;
    cardsContainer.classList.add(isMobile ? 'slide-out-right' : 'slide-out-right');
    
    setTimeout(() => {
      setCurrentSlide(prev => (prev === 1 ? totalSlides : prev - 1));
      setCurrentCardIndex(0); // Reset to first card when changing slides on mobile
      cardsContainer.classList.remove(isMobile ? 'slide-out-right' : 'slide-out-right');
      cardsContainer.classList.add(isMobile ? 'slide-in-left' : 'slide-in-left');
      
      setTimeout(() => {
        cardsContainer.classList.remove(isMobile ? 'slide-in-left' : 'slide-in-left');
        setIsAnimating(false);
      }, 600);
    }, 400);
  };
  
  // Parallax effect
  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current && cardsRef.current) {
        const scrollPosition = window.scrollY;
        const sectionPosition = sectionRef.current.offsetTop;
        const offset = scrollPosition - sectionPosition;
        
        if (offset > -400 && offset < 400) {
          // Apply parallax effect to cards
          const cards = cardsRef.current.querySelectorAll('.feature-card');
          cards.forEach((card, index) => {
            const translateY = (offset * 0.03) * (index % 2 === 0 ? 1 : -1);
            const rotateZ = (offset * 0.005) * (index % 2 === 0 ? 1 : -1);
            card.style.transform = `translateY(${translateY}px) rotateZ(${rotateZ}deg)`;
          });
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  // Auto slide transition
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isAnimating) {
        if (isMobile) {
          nextCard();
        } else {
          nextSlide();
        }
      }
    }, 10000);
    
    return () => clearInterval(interval);
  }, [currentSlide, currentCardIndex, isAnimating, isMobile]);
  
  // Apply custom animations to the cards
  useEffect(() => {
    const cards = document.querySelectorAll('.feature-card');
    cards.forEach((card, index) => {
      card.classList.add('card-appear');
      card.style.animationDelay = `${index * 150}ms`;
      
      // Add active class to the current card on mobile
      if (isMobile && index === currentCardIndex) {
        card.classList.add('active');
      } else if (isMobile) {
        card.classList.remove('active');
      }
    });
  }, [currentSlide, currentCardIndex, isMobile]);

  // Add some floating animations to background elements
  useEffect(() => {
    const addFloatingElements = () => {
      if (sectionRef.current) {
        const section = sectionRef.current;
        
        // Clear any existing floating elements
        const existingElements = section.querySelectorAll('.floating-element');
        existingElements.forEach(el => el.remove());
        
        // Create new floating elements
        for (let i = 0; i < 8; i++) {
          const element = document.createElement('div');
          element.className = 'floating-element';
          
          // Randomize appearance
          const size = Math.floor(Math.random() * 30) + 10;
          const isCircle = Math.random() > 0.5;
          const posX = Math.floor(Math.random() * 100);
          const posY = Math.floor(Math.random() * 100);
          const delay = Math.random() * 5;
          const duration = Math.random() * 10 + 10;
          
          element.style.width = `${size}px`;
          element.style.height = `${size}px`;
          element.style.left = `${posX}%`;
          element.style.top = `${posY}%`;
          element.style.animationDelay = `${delay}s`;
          element.style.animationDuration = `${duration}s`;
          
          if (isCircle) {
            element.style.borderRadius = '50%';
            element.style.background = `rgba(255, 138, 0, ${Math.random() * 0.1})`;
          } else {
            element.style.transform = `rotate(${Math.random() * 45}deg)`;
            element.style.background = `rgba(255, 255, 255, ${Math.random() * 0.05})`;
          }
          
          section.appendChild(element);
        }
      }
    };
    
    addFloatingElements();
    
    return () => {
      if (sectionRef.current) {
        const existingElements = sectionRef.current.querySelectorAll('.floating-element');
        existingElements.forEach(el => el.remove());
      }
    };
  }, []);
  
  return (
    <section className="course-features-section" id="concepts" ref={sectionRef}>
      <div className="course-features-content">
        <h2 className="section-title">What You'll Learn</h2>
        <div className="title-underline"></div>
        
        <p className="section-description">
          Get real-world, project-based experience across essential DevOps tools and AWS services
        </p>
        
        <div className="features-slider">
          <div 
            className="features-cards" 
            ref={cardsRef}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            {featuresData[currentSlide - 1].map((feature, index) => (
              <div 
                className={`feature-card ${isMobile && index === currentCardIndex ? 'active' : ''}`}
                key={index}
                style={{
                  animationDelay: `${index * 0.1}s`,
                  transform: isMobile 
                    ? `perspective(1000px) rotateY(0deg)` 
                    : `perspective(1000px) rotateY(${(index - 1.5) * 5}deg)`
                }}
              >
                <h3>{feature.title}</h3>
                <p className="feature-subtitle">{feature.subtitle}</p>
                <div className="feature-image-container">
                  <img 
                    src={feature.image} 
                    alt={feature.alt} 
                    className="feature-image"
                  />
                </div>
              </div>
            ))}
          </div>
          
          <div className="slider-navigation">
            <button 
              className="nav-button prev" 
              onClick={isMobile ? prevCard : prevSlide} 
              aria-label="Previous slide"
              disabled={isAnimating}
            >
              <span className="arrow-left">&#10094;</span>
            </button>
            
            <div className="slider-pagination">
              {isMobile ? (
                // Mobile pagination shows current card out of total cards (24)
                <span className="mobile-pagination">
                  {((currentSlide - 1) * 4) + (currentCardIndex + 1)} / 24
                </span>
              ) : (
                // Desktop pagination shows slide numbers
                Array.from({length: totalSlides}, (_, i) => (
                  <React.Fragment key={i}>
                    <button 
                      className={`pagination-dot ${currentSlide === i+1 ? 'active' : ''}`}
                      onClick={() => {
                        if (!isAnimating) {
                          setCurrentSlide(i+1);
                        }
                      }}
                      aria-label={`Go to slide ${i+1}`}
                    >
                      {i+1}
                    </button>
                    {i < totalSlides - 1 && <span className="dot-separator">•••</span>}
                  </React.Fragment>
                ))
              )}
            </div>
            
            <button 
              className="nav-button next" 
              onClick={isMobile ? nextCard : nextSlide} 
              aria-label="Next slide"
              disabled={isAnimating}
            >
              <span className="arrow-right">&#10095;</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CourseFeaturesSection; 